export default "__VITE_ASSET__BkZMZipC__"